<div class="indicator-container fx-layout-row fx-justify-center fx-align-stretch">
  @for (indicator of indicators; track indicator.label) {
    <indicator-widget [icon]="indicator.icon"
                      [isAnyFilterPresent]="isAnyFilterPresent()"
                      [formatType]="indicator.formatType"
                      [suffix]="indicator.suffix"
                      [label]="indicator.label"
                      [totalValue]="indicator.totalValue"
                      [filteredValue]="indicator.filteredValue">
    </indicator-widget>
  }
</div>
